// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1GIyM","name":"Header_name__3WuAe","birthday":"Header_birthday__37iQo","skeleton":"Header_skeleton__1i3IC"};